<template>
  <v-list two-line>
    <app-notfound v-if="!favorites.length && !appLoading"/>
    <app-list-transition v-else>
      <template v-for="(contact, index) in favorites">
        <v-list-tile
          v-ripple
          :class="{'list-item--selected': selectedUser === contact}"
          :key="contact.id"
          @click="select(contact.name)"
          avatar>

          <div class="pa-2">
            <app-avatar :id="contact.avatar" :size="48" :isOnline="contact.isOnline" />
          </div>

          <v-list-tile-content class="pl-2">
            <v-list-tile-title>{{contact.displayName}}</v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <app-favorite-button
              :isFavorite="contact.isFavorite"
              @click.stop="toggleFavorite(contact)" />
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key="index"/>
      </template>
    </app-list-transition>
  </v-list>
</template>

<script>
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';
import {mapState} from 'vuex';

export default {
  data() {
    return {
      selectedUser: null
    };
  },

  computed: {
    ...mapState({
      appLoading: state => state.appLoading
    }),

    ...mapGetters('user', {
      favorites: 'favorites'
    })
  },

  methods: {
    ...mapActions('user', {
      toggleContactFavorite: 'toggleContactFavorite'
    }),

    ...mapActions('chat', {
      switchChat: 'switchChat'
    }),

    toggleFavorite(contact) {
      this.toggleContactFavorite({
        id: contact.id,
        username: contact.name,
        isFavorite: contact.isFavorite
      });
    },

    select(username) {
      this.selectedUser = username;
      this.changeRightPage('chat');
      this.switchChat({username});
    }
  }
};
</script>

<style lang="stylus" scoped>
</style>
